import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const MenuIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={className}
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7229 2.29346H4.4393C3.45422 2.29346 2.6582 3.08948 2.6582 4.07455V23.9352C2.6582 24.9203 3.45422 25.7163 4.4393 25.7163H19.8224C20.8075 25.7163 21.6035 24.9203 21.6035 23.9352L21.6831 22.184"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.787109 8.14429H4.51845"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.787109 14.0049H4.51845"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.787109 19.8557H4.51845"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.8722 1C26.5886 9.39801 26.1807 9.31841 24.6483 11.01C23.2951 12.5622 23.8623 12.5622 23.8424 16.7313C23.8424 17.4378 23.8623 18.1443 23.9021 18.8507C24.1807 23.7164 24.0613 27 22.8573 27C21.5439 27 21.5339 23.7164 21.8125 18.8507C21.8523 18.1443 21.8722 17.4378 21.8722 16.7313C21.8523 12.5622 22.4195 12.5622 21.0662 11.01C19.5339 9.31841 19.1259 9.39801 19.8424 1"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.832 1V6.48259"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.8516 1V6.48259"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0008 13.8757H16.8366H8.80676H7.64258"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0008 16.6816H16.8366H8.80676H7.64258"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0008 19.4875H16.8366H8.80676H7.64258"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8466 13.5873C16.8466 13.6868 16.8466 13.7763 16.8367 13.8659H8.80683C8.80683 13.7763 8.79688 13.6768 8.79688 13.5873C8.79688 11.3684 10.5979 9.56738 12.8267 9.56738C15.0556 9.56738 16.8466 11.3684 16.8466 13.5873Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8262 8.50244V9.56712"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MenuIcon;
